import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './Investor_Profile.css';

const Investor_Profile = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"INVESTOR_PROFILE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	INVESTOR_PROFILE:-1
  });


  const [INVESTOR_PROFILE, setINVESTOR_PROFILE] = React.useState(null);
  const [INVESTOR_PROFILE_D, setINVESTOR_PROFILE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Investor Profile');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/Investor_Profile',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewINVESTOR_PROFILE(clientInfo,"OpenNew");

		navigate('/Investor_Profile',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Investor_Profile_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(INVESTOR_PROFILE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutINVESTOR_PROFILE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostINVESTOR_PROFILE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewINVESTOR_PROFILE(clientInfo,"OpenNew");
		}
		navigate('/Investor_Profile',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Investor_Profile_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Investor_Profile_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Investor_Profile_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(INVESTOR_PROFILE));
		if(Temp_Data2.status!="New"){
			handleDeleteINVESTOR_PROFILE(Temp_Data2);
			navigate('/Investor_Profile#New',{replace:true});
		} 
		else 
			navigate('/Investor_Profile',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Investor_Profile',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Investor_Profile',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Investor_Profile',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Investor_Profile',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!INVESTOR_PROFILE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [INVESTOR_PROFILE]) ;


  
  
  var Ids = [];
  for(var Ele in INVESTOR_PROFILE){
	  for(var Sec in INVESTOR_PROFILE[Ele]){
		if(Sec == "id")
			Ids.push(INVESTOR_PROFILE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(INVESTOR_PROFILE[Ele]["status"]);
		else if(Array.isArray(INVESTOR_PROFILE[Ele][Sec]))
			  for(var Row in INVESTOR_PROFILE[Ele][Sec])  // Convert to INVESTOR_PROFILE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in INVESTOR_PROFILE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["INVESTOR_PROFILE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewINVESTOR_PROFILE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/INVESTOR_PROFILE`).then((response1) => {
		if(!INVESTOR_PROFILE) 
			setINVESTOR_PROFILE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/INVESTOR_PROFILE_D`).then((response2) => {
			setINVESTOR_PROFILE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddINVESTOR_PROFILE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewINVESTOR_PROFILE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/INVESTOR_PROFILE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setINVESTOR_PROFILE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataINVESTOR_PROFILE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/INVESTOR_PROFILE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutINVESTOR_PROFILE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/INVESTOR_PROFILE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostINVESTOR_PROFILE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/INVESTOR_PROFILE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteINVESTOR_PROFILE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/INVESTOR_PROFILE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_0"]=value;
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
	Form_Data_onChange("1","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_0",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_1"]=value;
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
	Form_Data_onChange("1","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_1",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
 }; 
  

const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_2"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_2",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
  }; 
  


const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_3"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_3",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
  }; 
  

  
      
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_4_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_4"]=value ? true : false; // optionally just use boolean
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
	Form_Data_onChange("1","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_4",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
 }; 
  


    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["2"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_0"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_0",value,Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
  }; 
  
    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["2"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_1"]=value;
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
	Form_Data_onChange("2","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_1",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
 }; 
  

const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["2"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_2"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_2",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
  }; 
  


const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["3"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_0"]=value;
	Form_Data_onChange("3","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_0",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
  }; 
  


const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["3"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_1"]=value;
	Form_Data_onChange("3","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_1",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
  }; 
  


const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["3"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_2"]=value;
	Form_Data_onChange("3","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_2",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
  }; 
  


const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["4"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_0"]=value;
	Form_Data_onChange("4","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_0",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
  }; 
  


const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["4"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_1"]=value;
	Form_Data_onChange("4","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_1",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
  }; 
  


const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["5"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_5_0"]=value;
	Form_Data_onChange("5","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_5_0",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
  }; 
  


const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_0",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
  }; 
  

    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_1"]=value;
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
	Form_Data_onChange("9","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_1",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_2"]=value;
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
	Form_Data_onChange("9","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_2",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_3"]=value;
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
	Form_Data_onChange("9","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_3",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_4"]=value;
	//handleAddINVESTOR_PROFILE(Temp_Data,App_Data['INVESTOR_PROFILE']);
	Form_Data_onChange("9","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_4",value,Temp_Data);
 	//handleLastDataINVESTOR_PROFILE(Temp_Data);
    setINVESTOR_PROFILE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!INVESTOR_PROFILE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedINVESTOR_PROFILE =JSON.parse(JSON.stringify(INVESTOR_PROFILE));
  updatedINVESTOR_PROFILE[Sec] = [...updatedINVESTOR_PROFILE[Sec], newRow];
  setINVESTOR_PROFILE(updatedINVESTOR_PROFILE);
};

const handleDeleteRow = (sec,index) => {
  const updatedINVESTOR_PROFILE = JSON.parse(JSON.stringify(INVESTOR_PROFILE));
  updatedINVESTOR_PROFILE[sec].splice(index, 1);
  setINVESTOR_PROFILE(updatedINVESTOR_PROFILE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Investor Profile`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Investor ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Investor ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_0" type="text" className="form-control" placeholder="Investor ID" value={INVESTOR_PROFILE["1"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_0`]} 
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Investor ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`User ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_1" type="text" className="form-control" placeholder="User ID" value={INVESTOR_PROFILE["1"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_1`]} 
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter User ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Investor Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_2"  value={INVESTOR_PROFILE["1"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_2`]} onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_2_Change} className="form-control" name="Investor Type"  >
						  <option value="Individual">Individual</option>
						  <option value="Joint Account">Joint Account</option>
						  <option value="Entity">Entity</option>
						  <option value="Trust">Trust</option>
						  <option value="IRA / Retirement Account">IRA / Retirement Account</option>
						  <option value="Accredited Investor">Accredited Investor</option>
						  <option value="Non-Accredited Investor">Non-Accredited Investor</option>
						  <option value="Institutional Investor">Institutional Investor</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Investor Type
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Residency State`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_3"  value={INVESTOR_PROFILE["1"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_3`]} onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_3_Change} className="form-control" name="Residency State"  >
						  <option value="AL">AL</option>
						  <option value="AK">AK</option>
						  <option value="AZ">AZ</option>
						  <option value="AR">AR</option>
						  <option value="CA">CA</option>
						  <option value="CO">CO</option>
						  <option value="CT">CT</option>
						  <option value="DE">DE</option>
						  <option value="FL">FL</option>
						  <option value="GA">GA</option>
						  <option value="HI">HI</option>
						  <option value="ID">ID</option>
						  <option value="IL">IL</option>
						  <option value="IN">IN</option>
						  <option value="IA">IA</option>
						  <option value="KS">KS</option>
						  <option value="KY">KY</option>
						  <option value="LA">LA</option>
						  <option value="ME">ME</option>
						  <option value="MD">MD</option>
						  <option value="MA">MA</option>
						  <option value="MI">MI</option>
						  <option value="MN">MN</option>
						  <option value="MS">MS</option>
						  <option value="MO">MO</option>
						  <option value="MT">MT</option>
						  <option value="NE">NE</option>
						  <option value="NV">NV</option>
						  <option value="NH">NH</option>
						  <option value="NJ">NJ</option>
						  <option value="NM">NM</option>
						  <option value="NY">NY</option>
						  <option value="NC">NC</option>
						  <option value="ND">ND</option>
						  <option value="OH">OH</option>
						  <option value="OK">OK</option>
						  <option value="OR">OR</option>
						  <option value="PA">PA</option>
						  <option value="RI">RI</option>
						  <option value="SC">SC</option>
						  <option value="SD">SD</option>
						  <option value="TN">TN</option>
						  <option value="TX">TX</option>
						  <option value="UT">UT</option>
						  <option value="VT">VT</option>
						  <option value="VA">VA</option>
						  <option value="WA">WA</option>
						  <option value="WV">WV</option>
						  <option value="WI">WI</option>
						  <option value="WY">WY</option>
						  <option value="DC">DC</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Residency State
				     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_4" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`US Tax Resident`)} <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_4" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_4_Change} 
					  checked={INVESTOR_PROFILE?.["1"]?.["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_4"] === "true" || INVESTOR_PROFILE?.["1"]?.["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_1_4"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Date of Birth`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_SECTION" className="row">
			                {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Date Of Birth`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_0" type="date"  value={INVESTOR_PROFILE["2"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_0`]} 
							onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_0_Change} style={{ borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Date Of Birth
					  </div>
				  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '4ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`SSN Last4`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_1" type="text" className="form-control" placeholder="SSN Last4" value={INVESTOR_PROFILE["2"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_1`]} 
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '4ch' }}>
						 {t(`Enter SSN Last4`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Tax ID Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_2"  value={INVESTOR_PROFILE["2"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_2`]} onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_2_2_Change} className="form-control" name="Tax ID Type"  >
						  <option value="SSN">SSN</option>
						  <option value="EIN">EIN</option>
						  <option value="ITIN">ITIN</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Tax ID Type
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Annual Income Range`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Annual Income Range`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_0"  value={INVESTOR_PROFILE["3"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_0`]} onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_0_Change} className="form-control" name="Annual Income Range"  >
						  <option value="Under $50k">Under $50k</option>
						  <option value="$50k-$100k">$50k-$100k</option>
						  <option value="$100k-$200k">$100k-$200k</option>
						  <option value="$200k-$500k">$200k-$500k</option>
						  <option value="Over $500k">Over $500k</option>
						  <option value="Prefer Not to Say">Prefer Not to Say</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Annual Income Range
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Net Worth Range`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_1"  value={INVESTOR_PROFILE["3"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_1`]} onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_1_Change} className="form-control" name="Net Worth Range"  >
						  <option value="Under $100k">Under $100k</option>
						  <option value="$100k-$500k">$100k-$500k</option>
						  <option value="$500k-$1M">$500k-$1M</option>
						  <option value="$1M-$5M">$1M-$5M</option>
						  <option value="Over $5M">Over $5M</option>
						  <option value="Prefer Not to Say">Prefer Not to Say</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Net Worth Range
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Investment Objective`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_2"  value={INVESTOR_PROFILE["3"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_2`]} onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_3_2_Change} className="form-control" name="Investment Objective"  >
						  <option value="Income">Income</option>
						  <option value="Growth">Growth</option>
						  <option value="Capital Preservation">Capital Preservation</option>
						  <option value="Diversification">Diversification</option>
						  <option value="Speculative">Speculative</option>
						  <option value="Balanced">Balanced</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Investment Objective
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Risk Tolerance`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Risk Tolerance`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_0"  value={INVESTOR_PROFILE["4"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_0`]} onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_0_Change} className="form-control" name="Risk Tolerance"  >
						  <option value="Low">Low</option>
						  <option value="Moderate">Moderate</option>
						  <option value="High">High</option>
						  <option value="Very High">Very High</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Risk Tolerance
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Liquidity Need`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_1"  value={INVESTOR_PROFILE["4"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_1`]} onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_4_1_Change} className="form-control" name="Liquidity Need"  >
						  <option value="Low">Low</option>
						  <option value="Moderate">Moderate</option>
						  <option value="High">High</option>
						  <option value="Immediate Liquidity Needed">Immediate Liquidity Needed</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Liquidity Need
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Investor Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_5_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Investor Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_5_0"  value={INVESTOR_PROFILE["5"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_5_0`]} onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_5_0_Change} className="form-control" name="Investor Status"  >
						  <option value="Prospect">Prospect</option>
						  <option value="Onboarding">Onboarding</option>
						  <option value="Approved">Approved</option>
						  <option value="Restricted">Restricted</option>
						  <option value="Suspended">Suspended</option>
						  <option value="Closed">Closed</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Investor Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_0"  value={INVESTOR_PROFILE["9"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_0`]} onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_1" type="text" className="form-control" placeholder="Created By" value={INVESTOR_PROFILE["9"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_1`]} 
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_2" type="text" className="form-control" placeholder="Created At" value={INVESTOR_PROFILE["9"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_2`]} 
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_3" type="text" className="form-control" placeholder="Updated By" value={INVESTOR_PROFILE["9"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_3`]} 
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_4" type="text" className="form-control" placeholder="Updated At" value={INVESTOR_PROFILE["9"][`PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_4`]} 
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_PROFILE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default Investor_Profile;  